import { mapRange } from '../../utils/math';
export class ThreeJsDAELoader {
    constructor(crossOrigin) {
        this.model = null;
        this.onProgress = null;
        this.onLoaded = null;
        this.onError = null;
        this.crossOrigin = crossOrigin;
        this.loadingManagerOnLoad = this.loadingManagerOnLoad.bind(this);
        this.loadingManagerOnProgress = this.loadingManagerOnProgress.bind(this);
        this.loadingManagerOnError = this.loadingManagerOnError.bind(this);
        this.colladaLoaderOnLoad = this.colladaLoaderOnLoad.bind(this);
        this.colladaLoaderOnProgress = this.colladaLoaderOnProgress.bind(this);
        this.colladaLoaderOnError = this.colladaLoaderOnError.bind(this);
    }
    load(url) {
        this.colladaUrl = url;
        this.loadingManager = new window.THREE.LoadingManager();
        this.loadingManager.onLoad = this.loadingManagerOnLoad;
        this.loadingManager.onProgress = this.loadingManagerOnProgress;
        this.loadingManager.onError = this.loadingManagerOnError;
        // If we tga => png
        /*
        this.loadingManager.setURLModifier((url) => {
        const replaced = url.replace('.tga', '.png');
        return replaced;
        });
        */
        this.colladaLoader = new window.THREE.ColladaLoader(this.loadingManager);
        this.colladaLoader.setCrossOrigin(this.crossOrigin);
        this.colladaLoader.load(this.colladaUrl, this.colladaLoaderOnLoad, this.colladaLoaderOnProgress, this.colladaLoaderOnError);
    }
    loadingManagerOnLoad() {
        if (!this.collada) {
            return;
        }
        this.onLoaded(this.collada.scene);
    }
    loadingManagerOnProgress(url, itemsLoaded, itemsTotal) {
        const percentComplete = itemsLoaded === 1 && itemsTotal === 1 ? 100 : ((itemsLoaded - 1) / (itemsTotal - 1)) * 100;
        this.onProgress(mapRange(percentComplete, 0, 100, 50, 100));
    }
    loadingManagerOnError(url) {
        // this.onError(`ThreeJsDAELoader: Failed loading ${url}`);
    }
    colladaLoaderOnLoad(collada) {
        this.collada = collada;
    }
    colladaLoaderOnProgress(xhr) {
        if (xhr.lengthComputable) {
            const percentComplete = (xhr.loaded / xhr.total) * 100;
            this.onProgress(mapRange(percentComplete, 0, 100, 0, 50));
        }
    }
    colladaLoaderOnError(xhr) {
        this.onError(`ThreeJsDAELoader: Failed loading ${this.colladaUrl}`);
    }
    destroy() {
        if (this.loadingManager) {
            // Setting events to null at this point throws error in threejs ¯\_(ツ)_/¯
            this.loadingManager.onLoad = () => { };
            this.loadingManager.onProgress = () => { };
            this.loadingManager.onError = () => { };
            this.loadingManager.cancelLoading();
        }
    }
}
export class ThreeJsOBJLoader {
    constructor() {
        this.model = null;
        this.onProgress = null;
        this.onLoaded = null;
        this.onError = null;
    }
    load(url) { }
    destroy() { }
}
export class ThreeJsFBXLoader {
    constructor() {
        this.model = null;
        this.onProgress = null;
        this.onLoaded = null;
        this.onError = null;
    }
    load(url) { }
    destroy() { }
}
//# sourceMappingURL=ThreeJsModelLoaders.js.map